import React, { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import axios from "axios";
import { BallTriangle } from  'react-loader-spinner'
import { isMobile, browserName } from "react-device-detect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import Select from 'react-select';

import { regexp } from "../helper/regexp";

const cityList = require('../data/cities.json');
const stateList = require('../data/states.json');

const SignUp = () => {
    // loading and message display
    const [displayMsg, setDisplayMsg] = useState(null);
    const [loading, setLoading] = useState({show: false, message: ''});

    const queryParams = new URLSearchParams(window.location.search);
    const paymentStatus = queryParams.get('payment');
    const checkoutToken = queryParams.get('token');

    const [formSubmit, setFormSubmit] = useState(false);
    const [userInfo, setUserInfo] = useState({
        firstname: '',
        lastname: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        dob: '',
        marital_status: '',
        current_mortgage_amount: null,
        current_mortgage_interest_rate: null,
        mortgage_remaining_months: null,
        referral_code_used: ''
    });

    const [forPayment, setForPayment] = useState(false);
    const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);

    const handleSignUp = (e) => {
        setDisplayMsg(null)
        e.preventDefault();
        
        if( userInfo.firstname.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please enter your first name.'});
        }
        if( userInfo.lastname.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please enter your last name.'});
        }
        if( userInfo.email.trim() === '' || (userInfo.email.trim() !== '' && !regexp().emailRegExp.test(userInfo.email.trim()) ) ){
            return setDisplayMsg({type: 'error', message: 'Please enter a valid email address.'});
        }
        if( userInfo.address.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please enter your street address.'});
        }
        if( userInfo.state.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please select your state.'});
        }
        if( userInfo.city.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please select your city.'});
        }
        if( userInfo.zip.trim() === '' ){
            return setDisplayMsg({type: 'error', message: 'Please enter your zip code.'});
        }
        if( userInfo.dob === '' ){
            return setDisplayMsg({type: 'error', message: 'Please enter your date of birth.'});
        }
        if( userInfo.marital_status === '' ){
            return setDisplayMsg({type: 'error', message: 'Please select your city.'});
        }
        if( userInfo.current_mortgage_amount === '' || (userInfo.current_mortgage_amount !== '' && !regexp().numericRegExp.test(userInfo.current_mortgage_amount)) ){
            return setDisplayMsg({type: 'error', message: 'Please enter current mortgage amount.'});
        }
        if( userInfo.current_mortgage_interest_rate === '' || (userInfo.current_mortgage_interest_rate !== '' && !regexp().numericRegExp.test(userInfo.current_mortgage_interest_rate)) ){
            return setDisplayMsg({type: 'error', message: 'Please enter current mortgage interest rate (%).'});
        }
        if( userInfo.mortgage_remaining_months === '' || (userInfo.mortgage_remaining_months !== '' && !regexp().numericRegExp.test(userInfo.mortgage_remaining_months)) ){
            return setDisplayMsg({type: 'error', message: 'Please enter the remaining months left on your mortgage.'});
        }
        
        setFormSubmit(true);
        setLoading({show: true, message: 'Signing up. Please wait...'});

        axios.post(process.env.REACT_APP_DB_BASE_URL + "sign-up", {
            userInfo,
            browserName,
            isMobile
        })
        .then((response) => {
            setLoading({show: false, message: ''});
            if( response.data.type === 'success' ) {
                window.open(response.data.url, '_blank') 
                setForPayment(true)
            } else setDisplayMsg(response.data)
        })
        .catch((e) => {
            setLoading({show: false, message: ''});
            setDisplayMsg({type: 'error', message: 'App Error: Something went wrong. Please contact customer support.'});
        });
    }

    useEffect(() => {
        if( paymentStatus === 'success' && checkoutToken !== null ){
            setLoading({show: true, message: 'Checking membership payment status. Please wait...'});

            axios.post(process.env.REACT_APP_DB_BASE_URL + "check-membership-fee-status", {
                checkoutToken
            })
            .then((response) => {
                setLoading({show: false, message: ''});
                if(response.data.type === 'error') setDisplayMsg(response.data)
                setIsPaymentSuccess(response.data.type === 'success')
            })
            .catch((e) => {
                console.log(e)
                setLoading({show: false, message: ''});
                setDisplayMsg({type: 'error', message: 'App Error: Something went wrong. Please contact customer support.'});
            });
        }
    }, [paymentStatus, checkoutToken])

    return (
        <Container id="contact" fluid>
        <Row>
            <Col className="signupform-img z-1 p-0" md={12} lg={6}>
            <img src="./images/signup.jpg" className="img-fluid about-img" alt="commitment-only-sign-up-image" />
            </Col>
            <Col className="signupform p-5 z-1" md={12} lg={6}>
            <h1 className="text-center fw-bolder text-uppercase">Sign Up</h1>
            { displayMsg !== null && <Alert className={`alert-${displayMsg.type}`}>{displayMsg.message}</Alert>}
            {
                loading.show ?
                    <>
                        <BallTriangle
                            height={50}
                            width={50}
                            radius={5}
                            color="#90C2E7"
                            ariaLabel="ball-triangle-loading"
                            wrapperClass={{}}
                            wrapperStyle={{justifyContent: 'center', marginTop: 30}}
                            visible={true}
                        />
                        <p className="mt-4" style={{textAlign: 'center'}}>{loading.message}</p>
                    </>
                : 
                    !forPayment && !isPaymentSuccess ?
                        <Form className="fs-3">
                            <Form.Group controlId="formName" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.firstname.trim() === '' && 'text-danger'}>First Name</Form.Label>
                                <Form.Control
                                    className='fs-5'
                                    type="text"
                                    name="firstname"
                                    placeholder="Enter your first name"
                                    required
                                    value={userInfo.firstname}
                                    onChange={(el) => setUserInfo({...userInfo, firstname: el.target.value})}
                                />
                                <Form.Label className={formSubmit && userInfo.lastname.trim() === '' && 'text-danger'}>Last Name</Form.Label>
                                <Form.Control
                                    className='fs-5'
                                    type="text"
                                    name="lastname"
                                    placeholder="Enter your last name"
                                    required
                                    value={userInfo.lastname}
                                    onChange={(el) => setUserInfo({...userInfo, lastname: el.target.value})}
                                />
                            </Form.Group>

                            <Form.Group controlId="formEmail" className="mb-3">
                            <Form.Label className={formSubmit && !regexp().emailRegExp.test(userInfo.email.trim()) && userInfo.email.trim() === '' && 'text-danger'}>Email</Form.Label>
                            <Form.Control
                                className="fs-5"
                                type="email"
                                name="email"
                                placeholder="Enter your email"
                                required
                                value={userInfo.email}
                                onChange={(el) => setUserInfo({...userInfo, email: el.target.value.trim()})}
                            />
                            </Form.Group>

                            <Form.Group controlId="formAddress" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.address.trim() === '' && 'text-danger'}>Street Address</Form.Label>
                                <Form.Control
                                    className="fs-5"
                                    type="text"
                                    name="address"
                                    placeholder="Street address"
                                    required
                                    value={userInfo.address}
                                    onChange={(el) => setUserInfo({...userInfo, address: el.target.value})}
                                />
                            </Form.Group>
                            <Form.Group controlId="formState" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.state.trim() === '' && 'text-danger'}>State</Form.Label>
                                <Form.Group>
                                    <Select
                                        className='mb-2 fs-5'
                                        value={userInfo.state !== '' ? {label: userInfo.state, value: userInfo.state} : null}
                                        onChange={(el) => setUserInfo({...userInfo, state: el.value})}
                                        options={stateList}
                                    />
                                </Form.Group>
                            </Form.Group>
                            
                            {
                                cityList[userInfo.state] !== undefined &&
                                    <Form.Group controlId="formCity" className="mb-3">
                                        <Form.Label className={formSubmit && userInfo.city.trim() === '' && 'text-danger'}>City</Form.Label>
                                        <Form.Group>
                                            <Select
                                                className='mb-2 fs-5'
                                                value={userInfo.city !== '' ? {label: userInfo.city, value: userInfo.city} : null}
                                                onChange={(el) => setUserInfo({...userInfo, city: el.value})}
                                                options={userInfo.state !== '' ? cityList[userInfo.state].map(item => {return {value: `${item.charAt(0).toUpperCase()}${item.toLowerCase().slice(1)}`, label: `${item.charAt(0).toUpperCase()}${item.toLowerCase().slice(1)}`}}) : []}
                                            />
                                        </Form.Group>
                                    </Form.Group>
                            }

                            <Form.Group controlId="formZip" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.zip.trim() === '' && 'text-danger'}>Zip Code</Form.Label>
                                <Form.Control
                                    className="fs-5"
                                    type="text"
                                    name="address"
                                    placeholder="Zip code"
                                    required
                                    value={userInfo.zip}
                                    onChange={(el) => el.target.value.trim().length <= 5 && regexp().numericRegExp.test(el.target.value.trim()) && setUserInfo({...userInfo, zip: el.target.value})}
                                />
                            </Form.Group>
                                
                            <Form.Group controlId="formDOB" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.dob.trim() === '' && 'text-danger'}>Date of Birth</Form.Label>
                                
                                <Form.Group>
                                    <DatePicker 
                                        className='form-control fs-5'
                                        placeholderText="Enter birth date" 
                                        selected={userInfo.dob !== '' && userInfo.dob !== null ? new Date(userInfo.dob) : null} 
                                        onChange={(selected) => setUserInfo({...userInfo, dob: moment(selected).format('MM-DD-YYYY')})} 
                                    />
                                </Form.Group>
                            </Form.Group>
                            
                            <Form.Group controlId="formMaritalStatus" className="mb-3">
                                <Form.Label className={formSubmit && userInfo.marital_status === '' && 'text-danger'}>Marital Status</Form.Label>
                                <Form.Select className="fs-5" name="maritalStatus" required onChange={(el) =>  setUserInfo({...userInfo, marital_status: el.target.value})}>
                                    <option value="">Select status</option>
                                    <option value="Single">Single</option>
                                    <option value="Married">Married</option>
                                    <option value="Divorced">Divorced</option>
                                    <option value="Widowed">Widowed</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group controlId="formMortgageAmount" className="mb-3">
                                <Form.Label className={formSubmit && (!regexp().numericRegExp.test(userInfo.current_mortgage_amount) || userInfo.current_mortgage_amount === '') && 'text-danger'}>Current Mortgage Amount</Form.Label>
                                <Form.Control
                                    className="fs-5"
                                    type="text"
                                    name="mortgageAmount"
                                    placeholder="Enter your mortgage amount"
                                    required
                                    value={userInfo.current_mortgage_amount !== null ? userInfo.current_mortgage_amount : ''}
                                    onChange={(el) => regexp().numericRegExp.test(el.target.value.trim()) && setUserInfo({...userInfo, current_mortgage_amount: el.target.value})}
                                />
                                {
                                    userInfo.current_mortgage_amount !== null && userInfo.current_mortgage_amount !== '' &&
                                    <label className="fs-6">{parseFloat(userInfo.current_mortgage_amount).toLocaleString("en", { minimumFractionDigits: 2 })}</label>
                                }
                            </Form.Group>

                            <Form.Group controlId="formMortgageInterestRate" className="mb-3">
                            <Form.Label className={formSubmit && (!regexp().numericRegExp.test(userInfo.current_mortgage_interest_rate) || userInfo.current_mortgage_interest_rate === '') && 'text-danger'}>Current Mortgage Interest Rate (%)</Form.Label>
                            <Form.Control
                                className="fs-5"
                                type="number"
                                step="0.01"
                                name="mortgageInterestRate"
                                placeholder="Enter interest rate"
                                required
                                value={userInfo.current_mortgage_interest_rate !== null ? userInfo.current_mortgage_interest_rate : ''}
                                onChange={(el) => el.target.value > 0 && el.target.value <= 100 && setUserInfo({...userInfo, current_mortgage_interest_rate: el.target.value})}
                            />
                            </Form.Group>

                            <Form.Group controlId="formMortgageTerm" className="mb-3">
                            <Form.Label className={formSubmit && (!regexp().numericRegExp.test(userInfo.mortgage_remaining_months) || userInfo.mortgage_remaining_months === '') && 'text-danger'}>Remaining Months on Mortgage</Form.Label>
                            <Form.Control
                                className="fs-5"
                                type="text"
                                name="mortgageTerm"
                                placeholder="Enter remaining months on mortgage"
                                required
                                value={userInfo.mortgage_remaining_months !== null ? userInfo.mortgage_remaining_months : ''}
                                onChange={(el) => regexp().numericRegExp.test(el.target.value.trim()) && setUserInfo({...userInfo, mortgage_remaining_months: el.target.value})}
                            />
                            </Form.Group>
                            <Form.Group controlId="formMortgageTerm" className="mb-3">
                            <Form.Label>Referral Code</Form.Label>
                            <Form.Control
                                className="fs-5"
                                type="text"
                                name="referralCode"
                                placeholder="Enter referral code if any"
                                required
                                value={userInfo.referral_code_used !== null ? userInfo.referral_code_used : ''}
                                onChange={(el) => setUserInfo({...userInfo, referral_code_used: el.target.value.trim()})}
                            />
                            </Form.Group>
                            <Row className="text-center">
                            <Button
                                className="fs-4 mx-auto mt-5"
                                style={{
                                width: "30%",
                                }}
                                variant="dark"
                                type="submit"
                                onClick={handleSignUp}
                            >
                                Sign Up
                            </Button>
                            </Row>
                        </Form>
                    :
                        isPaymentSuccess ?
                            <>
                                <h3 className="mt-5 text-center fw-bolder text-uppercase success">Welcome to Commitment Only!</h3>
                                <p className="text-center">
                                    Thank you for joining Commitment Only by IF Holdings INC. An email confirmation was sent to your registered email.
                                </p>
                            </>
                        :
                            <>
                                <h3 className="mt-5 text-center fw-bolder text-uppercase success">Membership Fee Payment</h3>
                                <p className="text-center">To activate your membership, please proceed to pay the one-off membership fee on the window that was opened on your browser.</p>
                            </>
            }
            </Col>
        </Row>
        </Container>
    );
};

export default SignUp;
